export default "__VITE_ASSET__B7Kd9Ev2__"